import { MutationTree } from 'vuex';
import { Campus, City, LocationState } from './state';

const mutations: MutationTree<LocationState> = {
  SET_CITY(state, city: City) {
    state.city = city;
  },
  SET_AVAILABLE_CITIES(state, availableCities: City[]) {
    state.availableCities = availableCities;
  },
  SET_AVAILABLE_CAMPUSES(state, availableCampuses: Campus[]) {
    state.availableCampuses = availableCampuses;
  },
};

export default mutations;
